import { Image } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useMobile } from "../../../context/MobileContext";
import { useGetData } from "../../../hooks/indexData/indexData.hook";
import { USER_FIRST_TAB_PATH } from "../../../plugins/utils";
import styles from "./style.module.scss";

const Footer = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile } = useMobile();

  const { data } = useGetData();

  const itemEnum = [
    {
      content: t("footer.item.site"),
      subContent: [
        { title: t("footer.item.project"), type: "navigate", path: "/project", show: true },
        { title: t("footer.item.share"), type: "navigate", path: "/share", show: true },
        {
          title: t("footer.item.user"),
          type: "navigate",
          path: isMobile ? "/user" : USER_FIRST_TAB_PATH,
          show: true,
        },
        // {
        //   title: t("footer.menu.wallet"),
        //   type: "navigate",
        //   path: "/wallet/recharge/recharge",
        //   show: isMobile,
        // },
        // { title: t("user.myTeam"), type: "navigate", path: "/my-team", show: isMobile },
        // { title: t("normal.myProject"), type: "navigate", path: "/my-project", show: isMobile },
        { title: t("normal.blog"), type: "navigate", path: "/blog", show: isMobile },
        { title: t("normal.about"), type: "navigate", path: "/about", show: isMobile },
        { title: t("normal.tutorial"), type: "navigate", path: "/tutorial", show: isMobile },
      ],
    },
    {
      content: t("footer.item.important"),
      subContent: [
        { title: t("footer.item.privacy"), type: "windowOpen", path: "/privacy", show: true },
        { title: t("footer.item.terms"), type: "windowOpen", path: "/terms", show: true },
        // {  title: t("footer.item.cs"), type: "windowOpen", path: "/project", show: true },
      ],
    },
  ];

  const handleClickItem = (subItem) => {
    switch (subItem.type) {
      case "navigate":
        navigate(subItem.path);
        break;
      case "windowOpen":
        window.open(subItem.path, "_blank");
        break;
      default:
        break;
    }
  };

  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.top}>
          <div className={styles.leftContainer}>
            <Image src="/images/logo-long.png" alt="logo" preview={false} className={styles.logo} />
            {t("footer.text")}
          </div>
          <div className={styles.rightContainer}>
            {itemEnum.map((item, index) => {
              return (
                <div key={index} className={styles.itemGroup}>
                  <div className={styles.itemTitle}>{item.content}</div>
                  <div className={styles.itemOptions}>
                    {item.subContent.map((subItem, _index) => {
                      if (!subItem.show) return <div key={_index} />;
                      return (
                        <div
                          className={styles.itemOption}
                          key={_index}
                          onClick={() => handleClickItem(subItem)}
                        >
                          {subItem.title}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.bottom}>{t("footer.epilog")}</div>
        <div className={styles.socialMedia}>
          <div className={styles.mediaContainer}>
            <div className={styles.iconContainer}>
              <div
                className={styles.icon}
                onClick={() =>
                  data?.company_info.facebook && window.open(data?.company_info.facebook)
                }
              >
                <Image src={"/images/footer/fb.png"} alt="fb" preview={false} width={28} />{" "}
              </div>
              <div
                className={styles.icon}
                onClick={() =>
                  data?.company_info.twitter && window.open(data?.company_info.twitter)
                }
              >
                <Image src={"/images/footer/x-app.png"} alt="xApp" preview={false} width={28} />
              </div>
              <div>
                {t("footer.email") + " "}
                <a className={styles.email} href={`mailto:${data?.company_info.email}`}>
                  {data?.company_info.email}
                </a>
              </div>
            </div>
            <div className={styles.address}>
              {t("footer.address") + data?.company_info["Registered Office"]}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
